import { render, staticRenderFns } from "./MyBingohalls.vue?vue&type=template&id=53945f3c&scoped=true"
import script from "./MyBingohalls.vue?vue&type=script&lang=js"
export * from "./MyBingohalls.vue?vue&type=script&lang=js"
import style0 from "./MyBingohalls.vue?vue&type=style&index=0&id=53945f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53945f3c",
  null
  
)

export default component.exports